import { useSelector } from 'react-redux';
import { getAdminDisabled } from '../../authSlice/authSelectors';

function useAdminDisabled(): boolean {
  const adminDisabled = useSelector(getAdminDisabled);
  return adminDisabled;
}

export default useAdminDisabled;
